export const formatMoney = (value) => parseFloat(value).toFixed(2);
